import { useEffect } from 'react';

const CONSENT_CATEGORIES = ['C0001', 'C0002', 'C0003', 'C0004', 'C0005'] as const;

const buildConsentObject = (): Record<string, boolean> => {
    const activeGroups = globalThis.OnetrustActiveGroups ?? '';
    return CONSENT_CATEGORIES.reduce<Record<string, boolean>>((acc, category) => {
        acc[category] = activeGroups.includes(category);
        return acc;
    }, {});
};

const RETRY_INTERVAL_MS = 100;
const MAX_WAIT_MS = 30_000;

export const useConsentUpdateTracking = () => {
    useEffect(() => {
        let timeoutId: ReturnType<typeof setTimeout>;
        const startTime = Date.now();

        const handler = () => {
            globalThis.oneDataLayer.push({
                event: 'consentUpdated',
                timestamp: Date.now(),
                user: {
                    consent: buildConsentObject(),
                },
            });
        };

        const configureOneTrustConsentTracking = () => {
            if (globalThis.OneTrust) {
                globalThis.OneTrust.OnConsentChanged(handler);
            } else if (Date.now() - startTime < MAX_WAIT_MS) {
                timeoutId = setTimeout(configureOneTrustConsentTracking, RETRY_INTERVAL_MS);
            }
        };

        configureOneTrustConsentTracking();

        return () => clearTimeout(timeoutId);
    }, []);
};
